import type { MenuBoxesState } from 'reducers/menu-boxes/boxes'

export const getAvailableBoxTypes = (state: MenuBoxesState) => state.boxesV3.availableBoxes || []

export const getAvailableBoxesLoadingStatus = (state: MenuBoxesState) => state.boxesV3.isLoading
